import type { QueryApi } from "../../api/query";
import type { components } from "../../api/generated";

type DiscountCodeStatus = components["schemas"]["DiscountCodeStatus"];

export function createUseDiscountCodes($api: QueryApi) {
  return function useDiscountCodes(params: {
    page?: number;
    size?: number;
    search?: string;
    status?: DiscountCodeStatus;
    categoryId?: string;
  }) {
    return $api.useQuery("get", "/discount-codes", {
      params: {
        query: {
          page: params.page ?? 0,
          size: params.size ?? 30,
          search: params.search || undefined,
          status: params.status,
          categoryId: params.categoryId || undefined,
          sort: ["createdAt,desc"],
        },
      },
    }, {
      staleTime: 60_000,
    });
  };
}
